export const enum ResetTypesEnum {
  DAILY_TASKS = 'daily tasks',
  REWARDS = 'rewards',
  DAILY_VISITS = 'daily visits',
  SPECIAL_DROP = 'special drop',
}
